import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import DataItem from '../../../../components/dataItem';
import Divider from '../../../../components/divider';
import DateIndicator from '../../../../components/calendar/DateIndicator';
import StatsSection from '../../../../components/statsSection';
import StatisticsChart from '../../../../components/charts/barChart/StatisticsChart';

const ReportCard = ({
    activeView = 'week', //week, month, year
    title: titleProp,
    mainValue = 4759,
    mainUnit: mainUnitProp,
    stats = null,
    chartData = [],
    yAxisData = {
        maxValue: 15000,
        minValue: 0,
        averageValue: 0,
        yAxisValues: [0, 6000, 12000]
    },
    monthDays = null, // 월간차트일 때 해당 월의 일수
    selectedBarIndex = -1, // 선택된 바 인덱스
    onBarSelect = null, // 바 선택 콜백
    onPreviousWeek = () => { },
    onNextWeek = () => { },
    onPreviousMonth = () => { },
    onNextMonth = () => { },
    onPreviousYear = () => { },
    onNextYear = () => { },
    sx = {},
    ...props
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const title = titleProp ?? t('may_18_24');
    const mainUnit = mainUnitProp ?? t('didim_day');

    const CardContainer = styled(Box)(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        width: '100%',
        alignItems: 'flex-start',
    }));

    const HeaderSection = styled(Box)(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '100%',
    }));

    return (
        <CardContainer sx={sx} {...props}>
            {/* 헤더 섹션 */}
            <HeaderSection>
                {/* 날짜 헤더 */}
                <DateIndicator
                    title={title}
                    activeView={activeView}
                    onPreviousWeek={onPreviousWeek}
                    onPreviousMonth={onPreviousMonth}
                    onPreviousYear={onPreviousYear}
                    onNextWeek={onNextWeek}
                    onNextMonth={onNextMonth}
                    onNextYear={onNextYear}
                />
            </HeaderSection>

            {/* 메인 값 섹션 */}
            {mainValue !== '0 - 0' && (
                <Box sx={{ width: '100%' }}>
                    <DataItem
                        value={mainValue}
                        unit={mainUnit}
                        size="large"
                        sx={{ justifyContent: "left" }}
                    />
                </Box>
            )}

            {stats &&
                <>
                    {/* 구분선 */}
                    <Divider
                        lineColor={theme.palette.figma.white[20]}
                        padding="0 0"
                        gap="0"
                        sx={{ width: '100%' }}
                    />

                    {/* 통계 섹션 */}
                    <StatsSection stats={stats} activeView={activeView} isRangeData={props.isRangeData} />
                </>

            }

            {/* 차트 섹션 */}
            <StatisticsChart
                activeView={activeView}
                chartData={chartData}
                yAxisData={yAxisData}
                selectedBarIndex={selectedBarIndex}
                onBarSelect={onBarSelect}
                isRangeData={props.isRangeData}
            />

        </CardContainer >
    );
};

export default ReportCard;
